import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { theme } from 'configs';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import SwiperCore from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';
import { Pagination } from 'swiper/modules';
import { GlobalNavigate, SnackbarWrapper } from 'utils';
import App from './app';
import './i18n';
import './index.css';

const container = document.getElementById('root');
const root = createRoot(container!);

const authTheme = createTheme(theme);

SwiperCore.use([Pagination]);

root.render(
	// <React.StrictMode>
	<ThemeProvider theme={authTheme}>
		<BrowserRouter basename={process.env.PUBLIC_URL}>
			<GoogleOAuthProvider clientId="650649103618-8lj9gpp3ed4kruaec7frg8askgp3kr8h.apps.googleusercontent.com">
				<SnackbarWrapper>
					<GlobalNavigate />
					<QueryClientProvider client={new QueryClient()}>
						<App />
					</QueryClientProvider>
				</SnackbarWrapper>
			</GoogleOAuthProvider>
		</BrowserRouter>
	</ThemeProvider>
	// </React.StrictMode>
);
